// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-header {
  margin-top: 15px;
  margin-bottom: 15px;
}

.container-header .lock-icon {
  height: 22px;
  width: 18px;
  position: absolute;
  top: 9px;
}

.container-operand-wrapper {
  padding-right: 0px;
  padding-left: 15px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  /*color: white;*/
  font-weight: bold;
}

.container-operand-wrapper select {
  border-radius: 0px;
  background-color: #7a7a7a;
  color: white;
  -webkit-appearance: none !important;
}

.container-operand-wrapper select option {
  color: white;
}

.container-title {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-weight: bold;
  margin-left: 25px !important;
}

.container-title-no-icon {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-weight: bold;
}

.container-wrapper {
  margin-bottom: 15px;
  margin-left: 0px;
  margin-right: 0px;
}

.label-wrapper {
  top: 7px;
  font-size: 14px;
  padding-left: 0px;
  padding-right: 0px;
}

.select-wrapper {
  padding-right: 0px;
  padding-left: 0px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

/*Styles change for the dropdown in search filed - Start*/
.select-wrapper-input {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.select-wrapper-input .dropdown-caret-wrapper {
  right: 15px;
}

/*Styles change for the dropdown in search filed - End*/

.select-wrapper .select-prop {
  border-radius: 0px;
  -webkit-appearance: none !important;
}

.select-wrapper .select-prop-sm {
  padding-top: 0px;
  -webkit-appearance: none !important;
}

.select-prop-med {
  width: 160px !important;
}

.dropdown-caret-wrapper {
  position: absolute;
  top: 0;
  right: 0px;
  display: block;
  width: 35px;
  height: 42px;
  line-height: 35px;
  text-align: center;
  pointer-events: none;
  border-left: 1px solid #ccc;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: white;
}

.dropdown-caret-wrapper-sm {
  width: 30px !important;
  height: 30px !important;
  line-height: 20px !important;
}

.dropdown-caret-wrapper span {
  display: block;
  margin-top: 3px;
}

.dropdown-caret-wrapper span img {
  height: 20px;
}

.dropdown-caret-wrapper-profile {
  width: 42px !important;
  line-height: 10px !important;
}

.action-wrapper {
  padding-top: 4px;
  padding-left: 0px;
  bottom: 3px;
}

.action-wrapper span {
  padding-right: 5px;
}

.action-wrapper span img {
  height: 38px;
}

.container-action-wrapper {
  margin-bottom: 15px;
  padding-right: 15px;
}

.container-action-wrapper .pull-right {
  /*margin-right: 2rem;*/
}

.container-action-wrapper .add-child {
  margin-right: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #7a7a7a;
}

.container-action-wrapper .add-child span {
  text-decoration: underline;
}

.container-action-wrapper .remove-child img {
  height: 25px;
}

.childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  /*padding-top: 15px; */
  background-color: white;
  /*padding-bottom: 15px;*/
}

/*.childContainer:hover {
    border: 1px solid #7f7f7f;
}*/

.childContainer-Color {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  /*padding-top: 15px; */
  background-color: #f0f0f0;
  /*padding-bottom: 15px;*/
}

#childContainer #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: #f0f0f0;
}

#childContainer #childContainer #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: white;
}

#childContainer #childContainer #childContainer #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: #f0f0f0;
}

#childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: white;
}

#childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: #f0f0f0;
}

#childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer
  #childContainer {
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 0px;
  margin-top: 15px;
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/nestedcontainer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,uDAAuD;;AAEvD;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;EAME,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".container-header {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.container-header .lock-icon {\n  height: 22px;\n  width: 18px;\n  position: absolute;\n  top: 9px;\n}\n\n.container-operand-wrapper {\n  padding-right: 0px;\n  padding-left: 15px;\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  /*color: white;*/\n  font-weight: bold;\n}\n\n.container-operand-wrapper select {\n  border-radius: 0px;\n  background-color: #7a7a7a;\n  color: white;\n  -webkit-appearance: none !important;\n}\n\n.container-operand-wrapper select option {\n  color: white;\n}\n\n.container-title {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  font-weight: bold;\n  margin-left: 25px !important;\n}\n\n.container-title-no-icon {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  font-weight: bold;\n}\n\n.container-wrapper {\n  margin-bottom: 15px;\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.label-wrapper {\n  top: 7px;\n  font-size: 14px;\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.select-wrapper {\n  padding-right: 0px;\n  padding-left: 0px;\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n/*Styles change for the dropdown in search filed - Start*/\n.select-wrapper-input {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.select-wrapper-input .dropdown-caret-wrapper {\n  right: 15px;\n}\n\n/*Styles change for the dropdown in search filed - End*/\n\n.select-wrapper .select-prop {\n  border-radius: 0px;\n  -webkit-appearance: none !important;\n}\n\n.select-wrapper .select-prop-sm {\n  padding-top: 0px;\n  -webkit-appearance: none !important;\n}\n\n.select-prop-med {\n  width: 160px !important;\n}\n\n.dropdown-caret-wrapper {\n  position: absolute;\n  top: 0;\n  right: 0px;\n  display: block;\n  width: 35px;\n  height: 42px;\n  line-height: 35px;\n  text-align: center;\n  pointer-events: none;\n  border-left: 1px solid #ccc;\n  cursor: pointer;\n  border: 1px solid #ccc;\n  background-color: white;\n}\n\n.dropdown-caret-wrapper-sm {\n  width: 30px !important;\n  height: 30px !important;\n  line-height: 20px !important;\n}\n\n.dropdown-caret-wrapper span {\n  display: block;\n  margin-top: 3px;\n}\n\n.dropdown-caret-wrapper span img {\n  height: 20px;\n}\n\n.dropdown-caret-wrapper-profile {\n  width: 42px !important;\n  line-height: 10px !important;\n}\n\n.action-wrapper {\n  padding-top: 4px;\n  padding-left: 0px;\n  bottom: 3px;\n}\n\n.action-wrapper span {\n  padding-right: 5px;\n}\n\n.action-wrapper span img {\n  height: 38px;\n}\n\n.container-action-wrapper {\n  margin-bottom: 15px;\n  padding-right: 15px;\n}\n\n.container-action-wrapper .pull-right {\n  /*margin-right: 2rem;*/\n}\n\n.container-action-wrapper .add-child {\n  margin-right: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #7a7a7a;\n}\n\n.container-action-wrapper .add-child span {\n  text-decoration: underline;\n}\n\n.container-action-wrapper .remove-child img {\n  height: 25px;\n}\n\n.childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  /*padding-top: 15px; */\n  background-color: white;\n  /*padding-bottom: 15px;*/\n}\n\n/*.childContainer:hover {\n    border: 1px solid #7f7f7f;\n}*/\n\n.childContainer-Color {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  /*padding-top: 15px; */\n  background-color: #f0f0f0;\n  /*padding-bottom: 15px;*/\n}\n\n#childContainer #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: #f0f0f0;\n}\n\n#childContainer #childContainer #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: white;\n}\n\n#childContainer #childContainer #childContainer #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: #f0f0f0;\n}\n\n#childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: white;\n}\n\n#childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: #f0f0f0;\n}\n\n#childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer\n  #childContainer {\n  margin-bottom: 15px;\n  margin-left: 15px;\n  margin-right: 0px;\n  margin-top: 15px;\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
